export default __webpack_public_path__ + "static/media/bateria4tom.918a2b52.png";